/** Shopify CDN: Minification failed

Line 107:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 108:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 126:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 129:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 133:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 133:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 134:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 143:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 161:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 166:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 92:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 93:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 111:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 114:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 118:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 118:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 119:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 128:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 146:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 151:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 77:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 78:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 96:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 99:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 103:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 103:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 104:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 113:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 131:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 136:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 62:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 63:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 81:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 88:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 88:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 89:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 98:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 116:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 121:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 47:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 48:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 66:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 69:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 73:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 73:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 74:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 83:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 101:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 106:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 32:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 33:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 51:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 58:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 59:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 68:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 86:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 91:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
/** Shopify CDN: Minification failed

Line 17:41 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 18:15 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 36:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 39:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 43:18 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:52 Transforming default arguments to the configured target environment ("es5") is not supported yet
Line 44:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 53:10 Transforming const to the configured target environment ("es5") is not supported yet
Line 71:6 Transforming const to the configured target environment ("es5") is not supported yet
Line 76:22 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
... and 6 more hidden warnings

**/
if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false, true));
      });
      if (this.dataset.desktopLayout === 'thumbnail_slider' && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      if (event.detail.currentElement == undefined) return;

      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend, scrollIntoView = true) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if ((!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') && scrollIntoView) {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('[id^="Slide-"]').forEach((element) => {
        element.classList.remove('is-active');
        element.querySelector('button').removeAttribute('aria-current');
      });
      thumbnail.classList.add('is-active');
      thumbnail.querySelector('button').setAttribute('aria-current', true);

      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}
